import { track } from '@fff-web/fff-analytics';

export const EVENT_PROPERTIES = {
  EXPERIENCE: 'box subscription cancel flow',
  OFFER_TYPE: 'reFill',
};

type EventProps = {
  experience: string;
  offer_type: string;
  cta_name?: string;
};

export const fireMembershipTrackEvent = (trackName: string, ctaName?: string) => {
  const props: EventProps = {
    experience: EVENT_PROPERTIES.EXPERIENCE,
    offer_type: EVENT_PROPERTIES.OFFER_TYPE,
  };

  if (ctaName) {
    props.cta_name = ctaName;
  }

  track({
    trackName,
    properties: props,
  });
};
